import { render, staticRenderFns } from "./smallBagMsg.vue?vue&type=template&id=fa0809a8&scoped=true"
import script from "./smallBagMsg.vue?vue&type=script&lang=js"
export * from "./smallBagMsg.vue?vue&type=script&lang=js"
import style0 from "./smallBagMsg.vue?vue&type=style&index=0&id=fa0809a8&prod&lang=scss"
import style1 from "./smallBagMsg.vue?vue&type=style&index=1&id=fa0809a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0809a8",
  null
  
)

export default component.exports